const es = {
  // Navigation
  nav_home: 'Inicio',
  nav_about: 'Nosotros',
  nav_services: 'Servicios',
  nav_fleet: 'Flota',
  nav_schedules: 'Horarios',
  nav_amenities: 'Comodidades',
  nav_contact: 'Contacto',
  nav_bookNow: 'Reservar',

  // Common
  common_backHome: 'Volver al Inicio',

  // Hero
  hero_tagline: 'Viaje Interurbano Premium · Panamá',
  hero_h1_line1: 'Experimenta',
  hero_h1_line2: 'Viajes de Lujo',
  hero_h1_line3: 'por Panamá',
  hero_subtitle: 'Phoenix Transportation redefine el transporte interurbano entre Ciudad de Panamá y Chitré — combinando comodidad de primera clase, servicio profesional y absoluta confiabilidad.',
  hero_cta1: 'Reserva tu Viaje',
  hero_cta2: 'Conoce Nuestra Flota',
  hero_card_dailyDeparture: 'Salida Diaria',
  hero_card_perSeat: 'Desde por Asiento',
  hero_card_journeyTime: 'Tiempo de Viaje',
  hero_scroll: 'Desplazar',

  // About
  about_eyebrow: 'Sobre Phoenix Transportation',
  about_h2_line1: 'Redefiniendo',
  about_h2_line2: 'el Transporte',
  about_h2_line3: 'en Panamá',
  about_p1: 'Phoenix Transportation es un servicio de autobús de lujo dedicado a brindar transporte interurbano seguro, cómodo y confiable entre <strong>Ciudad de Panamá y Chitré</strong>.',
  about_p2: 'Diseñada para satisfacer la creciente demanda de opciones de viaje premium, la empresa combina altos estándares de flota con eficiencia operativa — aportando un nuevo nivel de sofisticación a las rutas interurbanas de Panamá.',
  about_p3: 'Creemos que cada viaje debe ser un placer. Nuestro equipo de profesionales capacitados está comprometido a hacer que tu experiencia de viaje sea perfecta de principio a fin.',
  about_motto: 'Lujo. Seguridad. Confiabilidad.',
  about_stat_buses: 'Autobuses de Lujo',
  about_stat_seats: 'Asientos Premium',
  about_stat_service: 'Servicio Diario',
  about_stat_route: 'Ciudad a Ciudad',

  // Services
  services_eyebrow: 'Nuestros Servicios',
  services_h2_line1: 'Soluciones de',
  services_h2_line2: 'Viaje Completas',
  services_subtitle: 'Cada aspecto de tu viaje está cuidadosamente diseñado para ofrecer el más alto estándar de transporte interurbano en Panamá.',
  services_0_title: 'Rutas Exprés Interurbanas',
  services_0_desc: 'Servicio directo y sin escalas entre Ciudad de Panamá y Chitré con salida diaria. Nuestra ruta exprés está diseñada para viajeros que valoran la puntualidad y el confort por encima de todo.',
  services_1_title: 'Asientos y Comodidad Premium',
  services_1_desc: 'Todos los asientos son de primera clase. Disfruta de amplios sillones reclinables de cuero, espacio generoso para las piernas y control individual del clima, todo diseñado para el viajero exigente.',
  services_2_title: 'Seguridad y Confiabilidad',
  services_2_desc: 'Nuestros conductores certificados siguen estrictos protocolos de seguridad en cada ruta. Los autobuses se mantienen e inspeccionan regularmente para garantizar que siempre viajes con total tranquilidad.',
  services_3_title: 'Servicio de Conserjería Profesional',
  services_3_desc: 'Nuestro personal a bordo garantiza una experiencia de viaje sin contratiempos. Desde la asistencia al embarque hasta el soporte durante el viaje, brindamos un servicio de nivel hotelero en cada kilómetro.',
  services_4_title: 'Conectividad a Bordo',
  services_4_desc: 'Mantente conectado durante todo tu viaje con Wi-Fi de alta velocidad gratuito. Ya sea por trabajo o por placer, te mantenemos en línea y productivo en cada trayecto.',
  services_5_title: 'Asistencia con el Equipaje',
  services_5_desc: 'Manejo de equipaje gratuito para todos los pasajeros. Nuestro equipo te ayuda con la carga y descarga para que puedas concentrarte en el viaje sin ninguna molestia.',

  // Fleet Home Section
  fleet_eyebrow: 'Nuestra Flota',
  fleet_h2_line1: 'Autobuses de Lujo',
  fleet_h2_line2: 'para tu Comodidad',
  fleet_subtitle: 'Nuestra flota de 2 coaches de lujo de última generación se mantiene meticulosamente para ofrecer la mejor experiencia de viaje en cada ruta.',
  fleet_specs_title: 'Especificaciones de la Flota',
  fleet_spec_0: '57 Asientos Premium',
  fleet_spec_1: 'Aire Acondicionado Completo',
  fleet_spec_2: 'Wi-Fi a Bordo',
  fleet_spec_3: 'Amplio Espacio para Piernas',
  fleet_spec_4: 'Conductores Profesionales',
  fleet_spec_5: 'Certificado de Seguridad',
  fleet_spec_6: 'Compartimento de Equipaje',
  fleet_spec_7: 'Puertos de Carga USB',
  fleet_bookSeat: 'Reservar un Asiento',
  fleet_route_departure_label: 'Salida',
  fleet_route_arrival_label: 'Llegada',
  fleet_route_duration_label: 'Duración',
  fleet_route_trips_label: 'Viajes Diarios',
  fleet_route_class_label: 'Clase',
  fleet_route_duration_val: '~3.5 Horas',
  fleet_route_trips_val: '1 Salida',
  fleet_route_class_val: 'Lujo',

  // Contact
  contact_eyebrow: 'Contáctanos',
  contact_h2_line1: 'Comienza tu',
  contact_h2_line2: 'Viaje Hoy',
  contact_phone_label: 'Teléfono',
  contact_email_label: 'Correo Electrónico',
  contact_route_label: 'Ruta',
  contact_hours_label: 'Horario de Servicio',
  contact_hours_val: 'Salida Diaria: 4:00 AM',
  contact_form_fullName: 'Nombre Completo',
  contact_form_fullName_ph: 'Tu nombre completo',
  contact_form_email: 'Correo Electrónico',
  contact_form_email_ph: 'tu@correo.com',
  contact_form_phone: 'Número de Teléfono',
  contact_form_phone_ph: '+507 0000-0000',
  contact_form_travelDate: 'Fecha de Viaje',
  contact_form_route: 'Ruta',
  contact_form_route_ph: 'Selecciona tu ruta',
  contact_form_route_opt1: 'Ciudad de Panamá → Chitré',
  contact_form_route_opt2: 'Chitré → Ciudad de Panamá',
  contact_form_route_opt3: 'Ida y Vuelta',
  contact_form_message: 'Mensaje',
  contact_form_message_ph: 'Solicitudes especiales o preguntas...',
  contact_form_submit: 'Enviar Consulta',
  contact_form_sending: 'Enviando...',
  contact_form_note: 'Respondemos en menos de 24 horas',
  contact_form_required: 'requerido',
  contact_success_title: '¡Mensaje Recibido!',
  contact_success_desc: 'Gracias por contactar a Phoenix Transportation. Te responderemos dentro de las próximas 24 horas.',

  // Footer
  footer_tagline: 'Servicio de autobús interurbano de lujo que conecta Ciudad de Panamá y Chitré con comodidad, seguridad y estilo.',
  footer_motto: 'Lujo. Seguridad. Confiabilidad.',
  footer_quickLinks: 'Accesos Rápidos',
  footer_routes: 'Rutas',
  footer_contact: 'Contacto',
  footer_route1: 'Ciudad de Panamá → Chitré',
  footer_route2: 'Chitré → Ciudad de Panamá',
  footer_departure_label: 'Salida Diaria',
  footer_departure_val: '4:00 AM Todos los Días',
  footer_journey_label: 'Tiempo de Viaje',
  footer_journey_val: '~3.5 Horas',
  footer_privacy: 'Política de Privacidad',
  footer_terms: 'Términos de Servicio',

  // Schedules Page
  sched_backHome: 'Volver al Inicio',
  sched_title: 'Rutas y Horarios',
  sched_subtitle: 'Reserva tu asiento en nuestra salida de lujo diaria — partiendo a las 4:00 AM desde Ciudad de Panamá y Chitré',
  sched_stat_distance_label: 'Distancia',
  sched_stat_duration_label: 'Duración',
  sched_stat_departures_label: 'Salidas Diarias',
  sched_stat_price_label: 'Desde',
  sched_stat_price_val: '$9 por Asiento',
  sched_stat_departures_val: '1 por Dirección',
  sched_oneWay: 'Solo Ida',
  sched_roundTrip: 'Ida y Vuelta',
  sched_roundTrip_note: 'Selecciona una salida de cada columna — te mostraremos el total antes de reservar.',
  sched_col1_title: 'Ciudad de Panamá → Chitré',
  sched_col1_sub_ow: 'Saliendo desde Ciudad de Panamá',
  sched_col1_sub_rt: 'Selecciona tu salida de ida',
  sched_col2_title: 'Chitré → Ciudad de Panamá',
  sched_col2_sub_ow: 'Saliendo desde Chitré',
  sched_col2_sub_rt: 'Selecciona tu salida de regreso',
  sched_selected_badge: 'Seleccionado',
  sched_price_label: 'Precio',
  sched_bookNow: 'Reservar Ahora',
  sched_select: 'Seleccionar',
  sched_selected_btn: 'Seleccionado',
  sched_summary_outbound: 'Ida',
  sched_summary_return: 'Regreso',
  sched_summary_total: 'Total',
  sched_not_selected: 'No seleccionado',
  sched_outbound_detail: 'Ciudad de Panamá → Chitré',
  sched_return_detail: 'Chitré → Ciudad de Panamá',
  sched_bookRoundTrip: 'Reservar Ida y Vuelta',
  sched_selectBothLegs: 'Selecciona Ambos Tramos para Continuar',
  sched_terminals_eyebrow: 'Puntos de Embarque',
  sched_terminals_title: 'Ubicaciones de Terminales',
  sched_terminals_subtitle: 'Encuéntranos en estas terminales. Llega al menos 20 minutos antes de tu salida programada.',
  sched_terminal_address: 'Dirección',
  sched_terminal_phone: 'Teléfono',
  sched_terminal_hours: 'Horario de Terminal',
  sched_info_title: 'Información Importante',
  sched_info_checkin_title: 'Hora de Embarque',
  sched_info_checkin_desc: 'Por favor llega a la terminal al menos 20 minutos antes de la hora de salida',
  sched_info_baggage_title: 'Política de Equipaje',
  sched_info_baggage_desc: '2 bolsos de mano (máx 10kg cada uno) y 2 maletas facturadas (máx 23kg cada una) incluidos',
  sched_info_cancel_title: 'Política de Cancelación',
  sched_info_cancel_desc: 'Cancelación gratuita hasta 24 horas antes de la salida. Reembolso del 50% dentro de las 24 horas',
  sched_info_ticket_title: 'Validación de Boleto',
  sched_info_ticket_desc: 'Se requiere documento de identidad válido. Se aceptan boletos digitales o impresos',

  // Amenities Page
  amen_eyebrow: 'Experiencia a Bordo',
  amen_title1: 'Comodidades',
  amen_title2: 'Premium',
  amen_subtitle: 'Cada detalle a bordo está cuidadosamente diseñado para que tu viaje sea tan agradable como el destino.',
  amen_stat1_val: '7',
  amen_stat1_label: 'Características Premium',
  amen_stat2_val: '100%',
  amen_stat2_label: 'Confort Garantizado',
  amen_stat3_val: '248 km',
  amen_stat3_label: 'Ruta de Lujo',
  amen_wifi_title: 'Wi-Fi de Alta Velocidad',
  amen_wifi_desc: 'Mantente conectado durante todo el viaje con Wi-Fi de alta velocidad gratuito, manteniéndote productivo y entretenido.',
  amen_wifi_detail: 'Nuestro Wi-Fi funciona con una conexión satelital dedicada, garantizando velocidades estables incluso en la carretera abierta.',
  amen_ac_title: 'Aire Acondicionado Completo',
  amen_ac_desc: 'Las zonas climáticas individuales aseguran que cada pasajero disfrute de la temperatura perfecta, sin importar el calor tropical de Panamá afuera.',
  amen_ac_detail: 'Cada sección del autobús mantiene su propia zona climática con control preciso de temperatura. Sin más peleas por el termostato — todos viajan con comodidad.',
  amen_seats_title: 'Asientos de Cuero Amplios',
  amen_seats_desc: 'Asientos de cuero premium y amplios diseñados para el máximo confort — dando a cada pasajero el espacio que merece en cada viaje.',
  amen_seats_detail: 'Nuestros asientos están fabricados con cuero de grano completo y soporte lumbar ergonómico. Con asientos extra anchos y abundante espacio para las piernas, cada viaje se siente de primera clase.',
  amen_recline_title: 'Asientos Completamente Reclinables',
  amen_recline_desc: 'Ajusta tu asiento al ángulo perfecto y acomódate para el viaje. Nuestros asientos completamente reclinables te permiten viajar en total relajación.',
  amen_recline_detail: 'Cada asiento se reclina suavemente al ángulo preferido con solo presionar un botón. Tu asiento se adapta a ti.',
  amen_screen_title: 'Pantallas de Entretenimiento',
  amen_screen_desc: 'Disfruta del entretenimiento a bordo con pantallas individuales con películas, música y contenido seleccionado para hacer volar los kilómetros.',
  amen_screen_detail: 'Cada asiento tiene una pantalla táctil HD personal cargada con una biblioteca de películas, series, música y podcasts.',
  amen_usb_title: 'Puertos de Carga USB',
  amen_usb_desc: 'Cada asiento tiene puertos de carga USB individuales para que tus dispositivos permanezcan completamente cargados durante todo el viaje.',
  amen_usb_detail: 'Nunca llegues con la batería descargada. Cada asiento incluye un puerto USB-A y USB-C con carga rápida.',
  amen_luggage_title: 'Almacenamiento Seguro de Equipaje',
  amen_luggage_desc: 'Los grandes compartimentos de equipaje y el almacenamiento superior mantienen tus pertenencias seguras y accesibles durante todo el viaje.',
  amen_luggage_detail: 'Generosos compartimentos bajo el autobús y compartimentos superiores brindan amplio espacio para todas tus maletas.',
  amen_learnMore: 'Ver más',
  amen_showLess: 'Ver menos',
  amen_gallery_eyebrow: 'Entra y Mira',
  amen_gallery_title1: 'Recorrido',
  amen_gallery_title2: 'Interior',
  amen_gallery_subtitle: 'Haz un recorrido visual por cada rincón de la cabina — desde el momento en que abordas hasta el asiento en el que te instalas.',
  amen_gal1_label: 'Cabina Principal',
  amen_gal1_caption: 'Filas de amplios asientos de cuero premium recorren toda la longitud de la cabina.',
  amen_gal2_label: 'Asientos Premium',
  amen_gal2_caption: 'Cuero de grano completo con soporte lumbar y controles de reclinación individuales a tu alcance.',
  amen_gal3_label: 'Entretenimiento',
  amen_gal3_caption: 'Pantallas táctiles HD personales en cada asiento con películas, música y contenido seleccionado.',
  amen_gal4_label: 'Carga y Conectividad',
  amen_gal4_caption: 'Puertos de carga USB-A y USB-C integrados en cada reposabrazos para que nunca te quedes sin batería.',
  amen_gal5_label: 'Control de Clima',
  amen_gal5_caption: 'Rejillas de aire individuales superiores permiten a cada pasajero ajustar su temperatura perfecta.',
  amen_gal6_label: 'Almacenamiento de Equipaje',
  amen_gal6_caption: 'Generosos compartimentos bajo el piso mantienen tu equipaje seguro durante todo el viaje.',
  amen_zoom_hint: 'Clic para ampliar',
  amen_cta_eyebrow: '¿Listo para Viajar?',
  amen_cta_title: 'Vive Cada Comodidad en tu Próximo Viaje',
  amen_cta_subtitle: 'Reserva tu asiento hoy y descubre por qué Phoenix Transportation es el servicio de lujo interurbano preferido de Panamá.',
  amen_cta_btn1: 'Ver Horarios y Reservar',
  amen_cta_btn2: 'Contáctanos',

  // Fleet Page
  fleet_page_eyebrow: 'Nuestra Flota',
  fleet_page_h1_line1: 'Conoce los Coaches que',
  fleet_page_h1_line2: 'Definen el Viaje',
  fleet_page_subtitle: 'Dos coaches de lujo de última generación — creados para el rendimiento, diseñados para el confort y mantenidos a la perfección en cada ruta entre Ciudad de Panamá y Chitré.',
  fleet_page_stat1_label: 'Coaches de Lujo',
  fleet_page_stat2_label: 'Asientos Totales',
  fleet_page_stat3_label: 'Días al Año',
  fleet_page_stat4_label: 'Ruta de Lujo',
  fleet_page_badge_flagship: 'Principal',
  fleet_page_badge_newest: 'Más Nuevo',
  fleet_page_seats_label: 'Asientos',
  fleet_page_tab_exterior: 'exterior',
  fleet_page_tab_interior: 'interior',
  fleet_page_tab_seat: 'Asientos',
  fleet_page_specs_title: 'Especificaciones',
  fleet_page_features_title: 'Características a Bordo',
  fleet_page_seatmap_title: 'Mapa de Asientos',
  fleet_page_seatmap_note: 'Pasa el cursor para resaltar · Todos los asientos son de clase premium',
  fleet_page_spec_capacity: 'Capacidad',
  fleet_page_spec_year: 'Año',
  fleet_page_spec_length: 'Longitud',
  fleet_page_spec_engine: 'Motor',
  fleet_page_spec_climate: 'Clima',
  fleet_page_spec_wifi: 'Conectividad',
  fleet_page_spec_entertainment: 'Entretenimiento',
  fleet_page_spec_charging: 'Carga',
  fleet_page_spec_val_capacity: '57 Asientos',
  fleet_page_spec_val_engine: 'Diésel Euro VI',
  fleet_page_spec_val_climate: 'A/C de Doble Zona',
  fleet_page_spec_val_wifi: 'Wi-Fi Satelital',
  fleet_page_spec_val_entertainment: 'Pantallas HD Individuales',
  fleet_page_spec_val_charging: 'USB-A + USB-C por Asiento',
  fleet_page_highlight_0: 'Asientos de cuero premium completamente reclinables',
  fleet_page_highlight_1: 'Pantallas táctiles HD de entretenimiento individuales',
  fleet_page_highlight_2: 'Wi-Fi a bordo con tecnología satelital',
  fleet_page_highlight_3: 'Aire acondicionado de precisión de doble zona',
  fleet_page_highlight_4: 'Carga rápida USB-A y USB-C en cada asiento',
  fleet_page_highlight_5: 'Grandes compartimentos de equipaje bajo el piso',
  fleet_page_highlight_6: 'Baño a bordo',
  fleet_page_highlight_7: 'Asistente bilingüe profesional en cada viaje',
  fleet_page_bus1_name: 'Phoenix I',
  fleet_page_bus1_tagline: 'La Experiencia Insignia',
  fleet_page_bus2_name: 'Phoenix II',
  fleet_page_bus2_tagline: 'Igualmente Lujoso, Siempre Listo',
  fleet_page_safety_eyebrow: 'Tu Seguridad, Nuestra Prioridad',
  fleet_page_safety_title1: 'Construidos sobre una',
  fleet_page_safety_title2: 'Base de Seguridad',
  fleet_page_safety_0_title: 'Certificado de Seguridad',
  fleet_page_safety_0_desc: 'Cada vehículo tiene la certificación completa de la autoridad de transporte panameña y se inspecciona mensualmente.',
  fleet_page_safety_1_title: 'Conductores Profesionales',
  fleet_page_safety_1_desc: 'Todos los conductores tienen un mínimo de 10 años de experiencia en largas distancias y pasan controles de bienestar regulares.',
  fleet_page_safety_2_title: 'Monitoreo con Cámaras',
  fleet_page_safety_2_desc: 'Las cámaras interiores y exteriores operan durante todo el viaje para la seguridad de los pasajeros.',
  fleet_page_safety_3_title: 'Primeros Auxilios',
  fleet_page_safety_3_desc: 'Botiquines de primeros auxilios certificados y personal capacitado presentes en cada viaje.',
  fleet_page_safety_4_title: 'Rastreo GPS',
  fleet_page_safety_4_desc: 'Rastreo GPS en tiempo real en cada coach, visible para despacho las 24/7.',
  fleet_page_safety_5_title: 'Supresión de Incendios',
  fleet_page_safety_5_desc: 'Sistemas automáticos de supresión de incendios instalados en ambos coaches.',
  fleet_page_cta_eyebrow: '¿Listo para Subir?',
  fleet_page_cta_title: 'Reserva tu Asiento en Phoenix I o Phoenix II',
  fleet_page_cta_subtitle: 'Una salida diaria desde Ciudad de Panamá y Chitré a las 4:00 AM. Los asientos son limitados — asegura el tuyo hoy.',
  fleet_page_cta_btn1: 'Ver Horarios y Reservar',
  fleet_page_cta_btn2: 'Explorar Comodidades',
  fleet_page_seatmap_front: 'Frente',
  fleet_page_seatmap_rear: 'Atrás',
  fleet_page_seatmap_door: 'Puerta',
  fleet_page_seatmap_all_premium: 'Todos los asientos son de clase premium',
};

export default es;
